import {
    API
} from "../http-common";

const RESOURCE_NAME = "/Messaging";

export default {
    getConversations(page = 1, pageSize = 50) {
        return API.get(`${RESOURCE_NAME}/Conversations?page=${page}&pageSize=${pageSize}`);
    },
    startConversation(clientId) {
        return API.post(`${RESOURCE_NAME}/Conversations`, { clientId });
    },
    getMessages(conversationId, page = 1, pageSize = 50) {
        return API.get(`${RESOURCE_NAME}/Conversations/${conversationId}/Messages?page=${page}&pageSize=${pageSize}`);
    },
    sendMessage(conversationId, body, attachmentIds = []) {
        return API.post(`${RESOURCE_NAME}/Conversations/${conversationId}/Messages`, { body, attachmentIds });
    },
    markRead(conversationId, upToMessageId = null) {
        return API.post(`${RESOURCE_NAME}/Conversations/${conversationId}/Read`, { upToMessageId });
    },
    getTotalUnread() {
        return API.get(`${RESOURCE_NAME}/UnreadCount`);
    },
    getContactableClientsCount() {
        return API.get(`${RESOURCE_NAME}/ContactableClientsCount`);
    },
    uploadAttachment(conversationId, file) {
        const formData = new FormData();
        formData.append("file", file);
        return API.post(`${RESOURCE_NAME}/Conversations/${conversationId}/Attachments`, formData);
    },
    downloadAttachment(attachmentId) {
        return API.get(`${RESOURCE_NAME}/Attachments/${attachmentId}`, {
            responseType: 'blob'
        });
    },
};
